module.exports = __webpack_public_path__ + "static/media/zoom-in.aa221c78.svg";